import React, { useEffect, useState } from "react";
import { getVoteById, submitVote } from "../../../services/voteServices";
import { toast } from "react-toastify";
import Button from "../../../components/Button/Button";
import { FaTimes, FaPaperPlane } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ParticipateVoteModal = ({
  isOpen,
  onClose,
  voteId,
  userId,
  refreshVotes,
}) => {
  const [vote, setVote] = useState(null);
  const [responses, setResponses] = useState({});

  useEffect(() => {
    if (isOpen && voteId) {
      fetchVote();
    }
  }, [isOpen, voteId]);

  const fetchVote = async () => {
    try {
      const data = await getVoteById(voteId);
      setVote(data);
    } catch (error) {
      toast.error("Erreur lors du chargement du vote");
    }
  };

  const handleChange = (questionId, value, type) => {
    if (type === "multiple") {
      setResponses((prev) => {
        const prevChoices = prev[questionId] || [];
        return {
          ...prev,
          [questionId]: prevChoices.includes(value)
            ? prevChoices.filter((v) => v !== value)
            : [...prevChoices, value],
        };
      });
    } else {
      setResponses((prev) => ({ ...prev, [questionId]: value }));
    }
  };

  const handleSubmit = async () => {
    const payload = {
      vote_id: voteId,
      user_id: userId,
      responses,
    };

    try {
      const result = await submitVote(payload);
      if (result) {
        toast.success("Réponses enregistrées !");
        onClose();
        refreshVotes();
      } else {
        throw new Error("Échec de la soumission");
      }
    } catch (error) {
      console.error("❌ Erreur soumission vote :", error);
      toast.error("Erreur lors de l'envoi des réponses");
    }
  };

  if (!isOpen || !vote) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-white dark:bg-slate-200 max-w-3xl w-full p-6 rounded-lg shadow-lg overflow-y-auto max-h-[90vh]">
        <h3 className="text-2xl font-bold mb-4 text-primary text-center">
          {vote.title}
        </h3>
        <p className="text-sm italic text-gray-700 dark:text-gray-800 mb-4 text-center">
          {vote.description}
        </p>

        <div className="space-y-6">
          {vote.questions.map((q) => (
            <div
              key={q.id}
              className="border border-gray-300 p-4 rounded-lg shadow-sm bg-gray-50"
            >
              <div className="mb-2">
                <ReactQuill
                  value={q.question_text}
                  readOnly={true}
                  theme="bubble"
                />
              </div>

              {q.type === "open" && (
                <input
                  type="text"
                  placeholder="Votre réponse"
                  value={responses[q.id] || ""}
                  onChange={(e) => handleChange(q.id, e.target.value, q.type)}
                  className="input input-bordered w-full"
                />
              )}

              {q.type === "single" &&
                q.choices.map((choice) => (
                  <label
                    key={choice.id}
                    className="flex items-center space-x-2 mb-1"
                  >
                    <input
                      type="radio"
                      name={`question_${q.id}`}
                      value={choice.id}
                      checked={responses[q.id] === choice.id}
                      onChange={() => handleChange(q.id, choice.id, q.type)}
                      className="radio"
                    />
                    <span>{choice.choice_text}</span>
                  </label>
                ))}

              {q.type === "multiple" &&
                q.choices.map((choice) => (
                  <label
                    key={choice.id}
                    className="flex items-center space-x-2 mb-1"
                  >
                    <input
                      type="checkbox"
                      value={choice.id}
                      checked={responses[q.id]?.includes(choice.id) || false}
                      onChange={() => handleChange(q.id, choice.id, q.type)}
                      className="checkbox"
                    />
                    <span>{choice.choice_text}</span>
                  </label>
                ))}
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-6 space-x-2">
          <Button
            text="Annuler"
            icon={FaTimes}
            onClick={onClose}
            className="gap-2"
          />
          <Button
            text="Envoyer"
            icon={FaPaperPlane}
            onClick={handleSubmit}
            className="gap-2"
          />
        </div>
      </div>
    </div>
  );
};

export default ParticipateVoteModal;
